import { createSelector } from 'reselect';

export const filtersDomainSelector = (state) => state.filters;
export const servicesSelector = createSelector(
  filtersDomainSelector,
  (filters) => filters.data.services
);

export const filtersSelector = createSelector(
  filtersDomainSelector,
  ({ filters }) => filters
);

export const selectedServicesSelector = createSelector(
  filtersSelector,
  servicesSelector,
  (filters, services) =>
    filters.services.map((serviceId) =>
      services.find((service) => service.id === +serviceId)
    )
);

export const presentationalFiltersSelector = createSelector(
  filtersDomainSelector,
  ({ presentationalFilters }) => presentationalFilters
);

export const officesSelector = createSelector(
  filtersDomainSelector,
  ({ offices }) => offices
);

export const filteredOfficesSelector = createSelector(
  filtersDomainSelector,
  ({ filteredOffices }) => filteredOffices
);

export const presentationalOfficesSelector = createSelector(
  filtersDomainSelector,
  ({ presentationalOffices }) => presentationalOffices
);

export const servicesFiltersSelector = createSelector(
  filtersSelector,
  ({ services }) => services
);

export const areasFiltersSelector = createSelector(
  filtersSelector,
  ({ areas }) => areas
);

export const undergroundsFiltersSelector = createSelector(
  filtersSelector,
  ({ undergrounds }) => undergrounds
);

export const servicesPresentationalFiltersSelector = createSelector(
  presentationalFiltersSelector,
  ({ services }) => services
);

export const selectedServicesCountSelector = createSelector(
  filtersSelector,
  ({ selectedServicesCount }) => selectedServicesCount
);

export const areasPresentationalFiltersSelector = createSelector(
  presentationalFiltersSelector,
  ({ areas }) => areas
);

export const undergroundsPresentationalFiltersSelector = createSelector(
  presentationalFiltersSelector,
  ({ undergrounds }) => undergrounds
);

export const searchValuesSelector = createSelector(
  filtersDomainSelector,
  ({ searchValues }) => searchValues
);

export const areasSearchValuesSelector = createSelector(
  searchValuesSelector,
  ({ areas }) => areas
);

export const servicesSearchValuesSelector = createSelector(
  searchValuesSelector,
  ({ services }) => services
);

export const undergroundsSearchValuesSelector = createSelector(
  searchValuesSelector,
  ({ undergrounds }) => undergrounds
);

export const officesCountSelector = createSelector(
  filtersDomainSelector,
  ({ offices }) => offices.length
);

export const anyFiltersChangedSelector = createSelector(
  filteredOfficesSelector,
  presentationalOfficesSelector,
  (filteredOffices, presentationalOffices) =>
    JSON.stringify(filteredOffices) === JSON.stringify(presentationalOffices)
);

export const showServicesSelector = createSelector(
  filtersDomainSelector,
  ({ showServices }) => showServices
);

export const showOfficeServicesSelector = createSelector(
  filtersDomainSelector,
  ({ showOfficeServices }) => showOfficeServices
);

export const filteredOfficesCountSelector = createSelector(
  filteredOfficesSelector,
  (offices) => offices.length
);

export const presentationalOfficesCountSelector = createSelector(
  presentationalOfficesSelector,
  (offices) => offices.length
);
